<template>
    <div class="row gy-2">
        <div class="col-12">
            <h5 class="mb-3">List of Your Refunds</h5>
            <div class="row mb-3 gy-2 justify-content-between">
                <div class="col-md-6 col-lg-5 d-flex">
                    <div class="input-group w-auto">
                        <b-form-select style="max-width:100px;" class="form-select" v-model="itemsPerPage"
                            :options="pageOptions"></b-form-select>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="input-group mb-0">
                        <input v-model="searchQuery" @input="updateSearchQuery" type="search" class="form-control"
                            placeholder="Search here..." aria-label="Search here..."
                            aria-describedby="button-search_TB">
                        <button @click="fetchItems()" class="btn btn-primary" type="button" id="button-search_TB"><span
                                class="ri ri-search-line"></span></button>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <p class="mb-0">Showing {{ paginationInfo }} results</p>
            </div>
            <div class="card">
                <div class="card-body p-3">
                    <div class="table-responsive mb-0 loading-viewport">
                        <CommonSpinner v-if="isLoading" :box="true" />
                        <b-table striped hover ref="selectableTable" :items="pageData.data" :fields="columns"
                            responsive="sm" align="middle">
                            <template v-for="(column, colIndex) in columns.filter((i) => i.sortable)"
                                v-slot:[`head(${column.key})`]>
                                <div :key="colIndex" @click="setSortOrder(column)" class="cursor-pointer
                                    d-flex align-items-center">
                                    {{ column.label }} <span v-html="getSortingLabel(column.key)"></span>
                                </div>
                            </template>
                            <template v-for="(column, colIndex) in columns.filter((i) => i.auto)"
                                v-slot:[`cell(${column.key})`]="data">
                                <div @click="navigateTo(data.item)" :key="colIndex"
                                    :style="{ 'width': `${column.width || '8'}rem` }"
                                    class="d-flex align-items-center">
                                    <CommonTableTemplate :item="data.item" :column="column" />
                                </div>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
            <div class="mb-4">
                <b-pagination v-model="currentPage" :limit="pageLimit" class="pagination-rounded"
                    :total-rows="pageData.total" :per-page="itemsPerPage"></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { commonSortingMixin } from '@shared/mixins/commonSortingMixin';
import { commonPaginationMixin } from '@shared/mixins/commonPaginationMixin';

export default {
    name: "refund-list",
    mixins: [
        commonSortingMixin,
        commonPaginationMixin
    ],
    data() {
        return {
            isLoading: false,
            popupModalShow: false,
            statusOptions: [
                { value: 'active', label: 'Active' },
                { value: 'completed', label: 'Completed' },
                { value: 'pending', label: 'Pending' },
                { value: 'paused', label: 'Paused' },
                { value: 'stopped', label: 'Stopped' },
                { value: 'complete_duration', label: 'Complete duration' },
                { value: 'cancelled', label: 'Cancelled' }
            ],
            searchQuery: "",
            columns: [
                { key: "category_title", auto: true, width: 10, label: "Title" },
                { key: "monthly_deduction", auto: true, label: "Monthly Deduction", sortable: true },
                { key: "amount", auto: true, label: "Total Amount", sortable: true },
                { key: "balance", auto: true, label: "Balance", sortable: true },
                { key: "status", auto: true, width: 4, label: "Status", sortable: true },
                { key: "duration", auto: true, width: 4, label: "Duration", sortable: true },
                { key: "reason", auto: true, width: 10, label: "Reason" },
                { key: "started_at", auto: true, label: "Started At", sortable: true },
                { key: "completed_at", auto: true, width:9, label: "Completed At", sortable: true }
            ],
            sortBy: {
                sort_column: "created_at",
                sort_direction: "desc"
            },
            pageData: {
                data: []
            },
        }
    },
    methods: {
        navigateTo(item) {

        },
        updateSearchQuery: _.debounce(function (string) {
            this.fetchItems()
        }, 2000),
        fetchItems(page, per_page = null) {
            let payload = {
                page: page || 1, per_page: per_page || this.itemsPerPage,
                ...this.sortBy,
            }
            if (this.searchQuery) { payload.search = this.searchQuery }

            this.isLoading = true
            this.$http.get(`/refunds?${new URLSearchParams(payload).toString()}`)
                .then((response) => {
                    this.isLoading = false
                    if (response.data.success) {
                        this.pageData = response.data.data
                        this.initializeAll();
                    }
                })
        },
        initializeAll() {
        },
    },
    created() {
        this.fetchItems()
    },
}

</script>
